import HybridTrendsAnalytics from './HybridTrendsAnalytics';
import './SuperAdminAnalytics.css';

function SuperAdminAnalytics({ token }) {
  // HybridTrendsAnalytics component handles all data fetching independently

  return (
    <div className="superadmin-analytics">
      {/* Hybrid Trends Analytics Section */}
      <HybridTrendsAnalytics token={token} />
    </div>
  );
}

export default SuperAdminAnalytics;
